import "../../../styles/login.css";
import useLogin from "./useLogin";
import LoginForm from "./LoginForm";
import LoginLayout from "./LoginLayout";

export default function LoginPage() {
  const login = useLogin();

  return (
    <LoginLayout login={login}>
      <h2 className="dr-reg-form-title">Login</h2>
      <LoginForm login={login} />
    </LoginLayout>
  );
}